import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import WhySection from './components/WhySection';
import CategoryCards from './components/CategoryCards';
import HowItWorks from './components/HowItWorks';
import ComparisonTable from './components/ComparisonTable';
import FAQ from './components/FAQ';
import CTASection from './components/CTASection';
import ArticleTeaser from './components/ArticleTeaser';
import { SITE_URL, SITE_NAME, SITE_DESCRIPTION, SITE_LOGO, SITE_LOCALE } from '@/utils/seo';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: SITE_NAME,
      url: SITE_URL,
      logo: {
        '@type': 'ImageObject',
        url: SITE_LOGO,
        width: '512',
        height: '512',
      },
      description: SITE_DESCRIPTION,
      sameAs: [
        'https://kaspreadsheet.com',
      ],
    },
    {
      '@type': 'WebSite',
      name: SITE_NAME,
      url: SITE_URL,
      description: SITE_DESCRIPTION,
      inLanguage: SITE_LOCALE,
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: 'https://kaspreadsheet.com/search?q={search_term_string}',
        },
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: 'Was ist ein OOPBuy Spreadsheet?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Ein OOPBuy Spreadsheet ist eine strukturierte Tabelle mit geprüften Produktlinks aus chinesischen Shops wie Taobao, Weidian und 1688. Es enthält Produktbilder, Preise, QC-Fotos und Bewertungen – alles an einem Ort.',
          },
        },
        {
          '@type': 'Question',
          name: 'Ist die Nutzung kostenlos?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Ja, unser OOPBuy Spreadsheet ist komplett kostenlos. Du kannst alle Produktlisten, Guides und Vergleichstabellen ohne Registrierung nutzen.',
          },
        },
        {
          '@type': 'Question',
          name: 'Wie aktuell sind die Produktdaten?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Unsere Produktlisten werden regelmäßig aktualisiert. Neue Produkte kommen täglich hinzu, und nicht verfügbare Links werden entfernt.',
          },
        },
        {
          '@type': 'Question',
          name: 'Funktioniert der Versand nach Deutschland?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Ja, alle Produkte in unserem Spreadsheet können nach Deutschland versendet werden. Wir erklären in unseren Guides genau, wie Versand, Zoll und Zahlung funktionieren.',
          },
        },
        {
          '@type': 'Question',
          name: 'Wie unterscheidet sich OOPBuy von anderen Agenten?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'OOPBuy bietet besonders günstige Versandkosten, eine benutzerfreundliche Oberfläche und exzellenten Kundenservice. In unserer Vergleichstabelle siehst du die Unterschiede zu Pandabuy, Sugargoo und anderen.',
          },
        },
      ],
    },
  ],
};

export default function Home() {
  return (
    <main className="min-h-screen">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeJsonLd) }}
      />
      <Navbar />
      <HeroSection />
      <TrustBar />
      <WhySection />
      <CategoryCards />
      <HowItWorks />
      <ComparisonTable />
      <ArticleTeaser />
      <FAQ />
      <CTASection />
      <Footer />
    </main>
  );
}